<template>
  <section class="intro" ref="section" :class="{'bg-playing': bgPlaying}">
    <div class="video-wrapper" :class="videoClass">
      <video autoplay muted loop playsinline disablePictureInPicture
             :src="videoSrc"
             ref="bgVideo"
             @loadedmetadata="bgLoaded"
             @play="bgStarted" />
    </div>
    <div class="overlay">
      <div class="image-box">
        <img src="../assets/images/windmill.jpg" alt="">
      </div>
      <div class="text-box">
        <headline kicker="Geschäftsbericht 2020" headline="Mit nachhaltigen Werten Zukunft sichern."/>
        <p>Ein Interview mit Dr. Susanna Zapreva und Prof. Dr. Marc Hansmann, Vorstand der enercity AG, über die Meilensteine des vergangenen Geschäftsjahres und die Bedeutung der vier Unternehmenswerte Kundenorientierung, Innovation, Verlässlichkeit und Nachhaltigkeit.</p>
        <button-link label="Video ansehen" @click.prevent="toggleVideo" />
      </div>
      <button class="scroller" @click="scrollClick" />
    </div>
    <transition name="fade">
      <div class="light-box" v-if="showVideo">
        <div class="video-window">
          <video :src="lightboxSrc" autoplay controls disablePictureInPicture />
        </div>
        <button class="closer" @click.prevent="toggleVideo"/>
      </div>
    </transition>
  </section>
</template>

<script>
  import Headline from "../elements/Headline";
  import ButtonLink from "../elements/ButtonLink";
  export default {
    name: "SectionIntro",
    components: {ButtonLink, Headline},
    data () {
      return {
        showVideo: false,
        bgPlaying: false,
        isWide: true,
        videoSrc: require('../assets/media/video-loop-xl.mp4'),
        lightboxSrc: require('../assets/media/interview.mp4'),
        ratio: 'regular'
      }
    },
    computed: {
      videoClass() {
        let c = this.ratio;
        if (this.isWide) {
          c += ' wide';
        }
        if (this.showVideo) {
          c += ' light-box-open';
        }
        return c;
      }
    },
    methods: {
      toggleVideo() {
        this.showVideo = !this.showVideo;
        this.$emit('prevent-scroll', {preventScroll: this.showVideo});
      },
      scrollClick() {
        this.$router.push({ path: 'profil' })
      },
      bgLoaded() {
        //this.$refs.bgVideo.currentTime = 21;
      },
      bgStarted() {
        this.bgPlaying = true;
      },
      resize() {
        const s = this.$refs.section;

        if (s.offsetWidth > 1000) {
          this.lightboxSrc = require('../assets/media/interview.mp4');
        }
        else {
          this.lightboxSrc = require('../assets/media/interview-sm.mp4');
        }

        if (s.offsetWidth > 1400) {
          this.videoSrc = require('../assets/media/video-loop-xl.mp4');
          this.ratio = 'regular';
          this.isWide = s.offsetWidth / s.offsetHeight > 16 / 9;
        }
        else if (s.offsetWidth > s.offsetHeight) {
          this.ratio = 'regular';
          this.isWide = s.offsetWidth / s.offsetHeight > 16 / 9;
          if (s.offsetWidth > 800) {
            this.videoSrc = require('../assets/media/video-loop-lg.mp4');
          }
          else {
            this.videoSrc = require('../assets/media/video-loop-sm.mp4');
          }
        }
        else {
          if (s.offsetWidth < 450) {
            this.videoSrc = require('../assets/media/video-loop-phone.mp4');
            this.ratio = 'phone';
            this.isWide = s.offsetWidth / s.offsetHeight > 420 / 680;
          }
          else {
            this.videoSrc = require('../assets/media/video-loop-tablet.mp4');
            this.ratio = 'tablet';
            this.isWide = s.offsetWidth / s.offsetHeight > 780 / 1000;
          }
        }
      }
    },
    emits: ['prevent-scroll', 'change-content'],
    mounted() {
      window.addEventListener('resize', this.resize);
      this.resize();
    }
  }
</script>

<style scoped>
  section {
    position: relative;
    width: 100vw;
    height: 100vh;
    background-color: #fff;
  }
  section:after {
    content: "";
    position: absolute;
    display: block;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: #fff;
    z-index: 2;
    pointer-events: none;
    transition: 0.5s ease;
    background-image: url(../assets/images/preloader.gif);
    background-repeat: no-repeat;
    background-position: center;
    background-size: 100px;
  }
  section.bg-playing:after {
    opacity: 0;
  }
  .video-wrapper {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    pointer-events: none;
    width: 177.8vh;
    background-color: #fff;
  }
  .video-wrapper.phone {
    width: 62vh;
  }
  .video-wrapper.phone:before {
    padding-top: 162%;
  }
  .video-wrapper.tablet {
    width: 78vh;
  }
  .video-wrapper.tablet:before {
    padding-top: 128.2%;
  }
  .video-wrapper.wide {
    width: 100% !important;
  }
  .video-wrapper video {
    position: relative;
    display: block;
    width: 100%;
    background-color: #fff;
  }
  .video-wrapper:after {
    content: "";
    position: absolute;
    display: block;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: -100%;
    background-color: rgba(16, 45, 97, 0.2);
  }
  .video-wrapper.light-box-open {
    transition: 0s linear 0.5s;
  }
  .overlay {
    position: absolute;
    right: 20%;
    bottom: 0;
    width: 400px;
  }
  .text-box {
    position: relative;
    padding: 10% 10% 18%;
  }
  .image-box {
    position: absolute;
    display: block;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
  }
  .image-box:after {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(20deg, #B1D995 0%, #3CB2B8 100%);
    opacity: 0.8;
  }
  img {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .light-box {
    position: fixed;
    display: flex;
    justify-content: center;
    align-items: center;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background-color: rgba(16, 45, 97, 0.96);
    z-index: 101;
  }
  .fade-enter-active, .fade-leave-active,
  .fade-enter-active .video-window, .fade-leave-active .video-window {
    transition: 0.4s ease;
  }
  .fade-enter-from, .fade-leave-to {
    opacity: 0;
  }
  .fade-enter-from .video-window, .fade-leave-to .video-window {
    transform: translate3d(0, 20%, 0) scale(1);
  }
  .fade-leave-to .video-window {
    transform: translate3d(0, 0, 0) scale(0.9);
  }
  .closer {
    position: absolute;
    top: 0;
    right: 0;
    width: 50px;
    height: 50px;
    margin: 30px;
    cursor: pointer;
    background-color: transparent;
    border: 0;
    padding: 0;
  }
  @media(max-width: 767px) {
    .closer {
      margin: 7px;
    }
  }
  .closer:before, .closer:after {
    content: "";
    position: absolute;
    display: block;
    width: 30px;
    height: 2px;
    background-color: #fff;
    left: 50%;
    right: 50%;
    transform: translate(-50%, -50%) rotate(45deg);
    transition: 0.2s ease;
  }
  .closer:after {
    transform: translate(-50%, -50%) rotate(-45deg);
  }
  .closer:hover:before, .closer:hover:after {
    width: 40px;
  }
  .closer:hover {
    outline: 0;
  }
  .video-window {
    position: relative;
    display: block;
    width: 1280px;
    max-width: 90%;
    transform: translate3d(0, 0, 0) scale(1);
  }
  .video-window:before {
    content: "";
    position: relative;
    display: block;
    padding-top: 56.25%;
    background-color: white;
    box-shadow: 0 10px 60px -20px rgba(0, 0, 0, 0.7);
  }
  .video-window video {
    position: absolute;
    display: block;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
  }
  video:focus {
    outline: 0;
  }
  .scroller {
    display: none;
  }
  @media(min-width: 1000px) {
    .scroller {
      position: relative;
      display: block;
      width: 40px;
      height: 40px;
      background-image: url(../assets/images/scroll.svg);
      background-size: 100%;
      margin: -20px 40px 40px;
      background-color: transparent;
      padding: 0;
      border: 0;
      float: right;
      cursor: pointer;
    }
    .text-box {
      padding-bottom: 0;
    }
  }
  @media(max-width: 999px) and (min-width: 768px) {
    .overlay {
      right: 38px;
    }
  }
  @media (max-width: 767px) {
    section {
      overflow: hidden;
    }
    .overlay {
      left: 50%;
      width: 90%;
      max-width: 400px;
      transform: translate(-50%, 0);
    }
    p {
      display: none;
    }
  }
</style>